import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { instance2 } from "../../utils/axiosInstance";
import { formatNumber } from "../../numberingformat";
import { formatNumberUS } from "../../numberingformatus";
import CalendarIcon from "../../img/calendaricon.svg";
import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
import "jspdf-autotable"; // Import the autotable plugin for jsPDF
import DapurIcon from "../../img/logodapursidebar.png";
import BgnIcon from "../../img/logobgn.png";
import { basecode } from "./baserobotocode";
import { basecodetmr } from "./basetmrcode";
import { basecodetmrbold } from "./basetmrboldcode";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { Button } from "../../shadcn/button";
import { ReactComponent as ListOn } from "../../img/CheckCircle.svg";
import { useMediaQuery } from "src/lib/hooks";
import { toast } from "sonner";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/shadcn/dialog";
import { EditIcon } from "lucide-react";

export default function OrdersTable() {
  const [data, setData] = useState([]);
  const [dataReceived, setDataReceived] = useState([]);
  const [filteredDataReceived, setFilteredDataReceived] = useState([]);
  const [receivedExist, setReceivedExist] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [sortSupplier, setSortSupplier] = useState(""); // For filtering by supplier
  const [sortKitchen, setSortKitchen] = useState(""); // For filtering by supplier
  const [sortIngredient, setSortIngredient] = useState(""); // For filtering by ingredient
  const [sortDate, setSortDate] = useState(""); // For filtering by ingredient
  const navigate = useNavigate();

  const roleId = parseInt(localStorage.getItem("roleId"), 10);
  const locationId = parseInt(localStorage.getItem("locationId"), 10);
  const kitchenId = parseInt(localStorage.getItem("kitchenId"), 10);
  const picName = localStorage.getItem("name");
  const userAuthentication = localStorage.getItem("userAuthentication");
  const adminId = localStorage.getItem("userId");
  const [weekDetails, setWeekDetails] = useState({
    weekNumber: 1,
    startDate: "",
    endDate: "",
  });

  const isDesktop = useMediaQuery("(min-width: 1024px)");
  // Access state from the navigate call
  const location = useLocation();

  // Extract startDate and endDate from the URL query string
  const queryParams = new URLSearchParams(location.search);
  const startDate = queryParams.get("startDate");
  const endDate = queryParams.get("endDate");
  const dateParam = queryParams.get("selectedDate");

  // state
  // state (you already have most of these)
  const [isEditOrderOpen, setIsEditOrderOpen] = useState(false);
  const [editOrderId, setEditOrderId] = useState(null);
  const [orderNoInput, setOrderNoInput] = useState("");
  const [originalOrderNo, setOriginalOrderNo] = useState("");
  const [orderNoError, setOrderNoError] = useState("");
  const [savingOrderNo, setSavingOrderNo] = useState(false);

  // confirm dialog state
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const openEditOrderDialog = (orderId, currentOrderNo) => {
    setEditOrderId(orderId);
    setOrderNoInput(currentOrderNo ?? "");
    setOriginalOrderNo(currentOrderNo ?? "");
    setOrderNoError("");
    setIsEditOrderOpen(true);
  };

  // Open confirm only if there is a change and input not empty
  const handleAttemptSave = () => {
    const next = (orderNoInput || "").trim();
    if (!next) {
      setOrderNoError("Nomor PO tidak boleh kosong.");
      return;
    }
    if (next === (originalOrderNo || "").trim()) {
      setOrderNoError("Nomor PO tidak berubah.");
      return;
    }
    setOrderNoError("");
    setIsConfirmOpen(true);
  };

  // Runs when user clicks "Ya, Simpan" on the confirm dialog
  const handleConfirmAndSave = async () => {
    const next = (orderNoInput || "").trim();
    setSavingOrderNo(true);
    setOrderNoError("");

    try {
      // 1) Check availability
      const checkRes = await instance2.get(
        `/check_order_no/${encodeURIComponent(next)}`,
      );
      const availableFlag = Array.isArray(checkRes?.data)
        ? checkRes.data[0]?.available
        : undefined;

      console.log("availableFlag", checkRes?.data[0]?.available);

      const isAvailable = String(availableFlag).trim().toUpperCase() === "Y";

      if (!isAvailable) {
        // Already exists -> notify user, stay in edit dialog
        setIsConfirmOpen(false);
        setIsEditOrderOpen(true);
        setOrderNoError("Nomor PO sudah digunakan. Silakan pilih nomor lain.");
        return;
      }

      // 2) Proceed to save
      const res = await instance2.post(`/change_order_no/${editOrderId}`, {
        order_no: next,
        admin_id: adminId,
      });

      if (res?.status === 200 || res?.status === "OK") {
        setIsEditOrderOpen(false);
        setIsConfirmOpen(false);
        if (typeof fetchData === "function") fetchData();
      } else {
        setIsConfirmOpen(false);
        setIsEditOrderOpen(true);
        setOrderNoError("Gagal menyimpan nomor PO.");
      }
    } catch (err) {
      console.error(err);
      setIsConfirmOpen(false);
      setIsEditOrderOpen(true);
      setOrderNoError(
        err?.response?.data?.message || "Terjadi kesalahan saat menyimpan.",
      );
    } finally {
      setSavingOrderNo(false);
    }
  };

  const handlePenerimaan = async () => {
    //navigate("/penerimaanPO")

    navigate(
      `/penerimaanPO?startDate=${startDate}&endDate=${endDate}&dateParam=${localDateString(new Date(dateParam))}`,
    );
  };

  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, "0");

    // console.log("startDate", thedate);
    const localDateString = `${year}-${month}-${day}`;

    return localDateString;
  };

  // Fetch table data
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log("day", startDate, endDate);
      //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
      const formattedStartDate = localDateString(new Date(startDate));
      const formattedEndDate = localDateString(new Date(endDate));

      const response = await instance2.post(`purchase_order`, {
        startdate: formattedStartDate,
        enddate: formattedEndDate,
      });

      //console.log('response1',response)
      const result = response.data?.data || response.data || [];
      setData(result);
      kitchenId
        ? setFilteredData(
            result.filter((item) => item.kitchen_id === kitchenId),
          )
        : // Initialize filtered data with full data
          setFilteredData(result);
    } catch (err) {
      setError(err.message || "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchDataReceived = async () => {
      try {
        setLoading(true);
        setError(null);

        const formattedStartDate = localDateString(new Date(startDate));
        const formattedEndDate = localDateString(new Date(endDate));

        const response = await instance2.get(
          `order_received/location/${locationId}/${formattedStartDate}/${formattedEndDate}`,
        );
        const result = response.data;
        setDataReceived(result);
        setReceivedExist(result.length);
        // // console.log("receivedExist finals",result.length)
        // //   //setFilteredDataReceived(result); // Initialize filtered data with full data
        // // console.log("test", response.data,
        //   `order_received/location/${locationId}/${formattedStartDate}/${formattedEndDate}`
        // );
      } catch (err) {
        //setError(err.message || "Failed to fetch data");
      }
    };
    fetchDataReceived();
    console.log("receivedExist final", receivedExist);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  // Group data by Order Number, then by Delivery Date
  const groupDataByOrderNumberAndDeliveryDate = (data) => {
    return data.reduce((acc, item) => {
      if (!acc[item.order_no]) {
        acc[item.order_no] = {};
      }

      const deliveryDate = localDateString(new Date(item.delivery_date)); // Extract date part (YYYY-MM-DD)

      if (!acc[item.order_no][deliveryDate]) {
        acc[item.order_no][deliveryDate] = [];
      }

      acc[item.order_no][deliveryDate].push(item);

      return acc;
    }, {});
  };

  //oke
  // Sort the grouped data by delivery date
  const sortGroupedDataByDate = (groupedData) => {
    for (const orderNumber in groupedData) {
      const orderDetails = groupedData[orderNumber];

      // Sort the delivery dates within each order
      const sortedDeliveryDates = Object.keys(orderDetails).sort(
        (a, b) => new Date(a) - new Date(b),
      );

      // Rebuild the orderDetails object with sorted delivery dates
      const sortedOrderDetails = {};
      sortedDeliveryDates.forEach((deliveryDate) => {
        sortedOrderDetails[deliveryDate] = orderDetails[deliveryDate];
      });

      groupedData[orderNumber] = sortedOrderDetails;
    }

    return groupedData;
  };
  // ⬇️ use this effect for filtering
  useEffect(() => {
    let next = data; // <-- always start from the full source

    if (sortSupplier) {
      next = next.filter((i) => i.supplier_name === sortSupplier);
    }
    if (sortKitchen) {
      next = next.filter((i) => i.kitchen_name === sortKitchen);
    }
    if (sortIngredient) {
      next = next.filter((i) => i.ingredient_name === sortIngredient);
    }
    if (sortDate) {
      next = next.filter((i) => i.delivery_date === sortDate);
    }

    setFilteredData(next);
  }, [data, sortSupplier, sortKitchen, sortIngredient, sortDate]);

  // Function to generate grey color for each delivery date
  const generateGreyColor = (index) => {
    const shadesOfGrey = [
      "#e5e5e5", // lightest grey
    ];
    return shadesOfGrey[index % shadesOfGrey.length]; // Loop through shades
  };

  const [position, setPosition] = useState([]); // Store enabled dates from API

  // Fetch API data with enabled dates
  const fetchPosition = async () => {
    try {
      const response = await instance2.get("admins");
      const data = response.data; // Access data from the response object

      // Find the matching user based on userAuthentication
      const matchingUser = data.find(
        (user) => user.username === userAuthentication,
      );

      // If a matching user is found, set the position (pos)
      if (matchingUser) {
        setPosition(matchingUser.pos);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchPosition(); // Fetch data when the component is mounted
  }, []);

  const handleDownloadPDF = async (
    orderNumber,
    orderDetails,
    supplierName,
    orderDate,
    receiverName,
    orderId,
  ) => {
    const doc = new jsPDF();
    const receiverAddress = "Kec. Arcamanik, Kota Bandung, Jawa Barat";
    // Embed the Roboto font (add the correct base64 font data here)
    // Embed Times New Roman Regular
    const tmrFontRegular = basecodetmr; // Base64 Times New Roman Regular
    doc.addFileToVFS("TimesNewRoman-Regular.ttf", tmrFontRegular);
    doc.addFont("TimesNewRoman-Regular.ttf", "TimesNewRoman", "normal");

    // Embed Times New Roman Bold
    const tmrFontBold = basecodetmrbold; // Base64 Times New Roman Bold
    doc.addFileToVFS("TimesNewRoman-Bold.ttf", tmrFontBold);
    doc.addFont("TimesNewRoman-Bold.ttf", "TimesNewRoman", "bold");

    // ✅ Set default font
    doc.setFont("TimesNewRoman", "normal");
    // Convert local icon to Base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const targetWidth = 180; // smaller resolution
          const targetHeight = 180;
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
          resolve(canvas.toDataURL("image/png")); // compress to WebP
        };
        img.onerror = (err) => reject(err);
      });

    const iconBase64 = await loadImageAsBase64(BgnIcon);

    // Title and Supplier Information Block
    const pageWidth = doc.internal.pageSize.width;
    const text = "PURCHASE ORDER";
    const textWidth = doc.getTextWidth(text);
    const xPosition = (pageWidth - textWidth) / 2;

    const addHeader = (
      doc,
      pageWidth,
      supplierName,
      orderNumber,
      orderDate,
      receiverName,
      iconBase64,
    ) => {
      const textYOffset = 10;

      // ✅ PURCHASE ORDER block on the RIGHT
      const rightMargin = 0;
      const blockX = pageWidth - rightMargin - 80; // Adjust width as needed
      const boxWidth = 60;
      const boxHeight = 6;

      // ✅ Calculate center X for the text above the boxes
      const boxLabelX = blockX + 5; // label start
      const boxValueX = blockX + 15; // box start (space after label)
      const centerTextX = boxValueX + boxWidth / 2; // center of the boxes

      // ✅ Icon on the LEFT
      const LEFT_MARGIN = 20;
      const RIGHT_MARGIN = 20;
      const RECT_PADDING = 4;
      const iconWidth = 23;
      const iconHeight = 23;
      const iconX = LEFT_MARGIN;
      const iconY = textYOffset + 2;
      doc.addImage(iconBase64, "PNG", iconX, iconY, iconWidth, iconHeight);

      // ✅ Title centered above the boxes
      doc.setFontSize(10);
      doc.setFont("TimesNewRoman", "bold");
      doc.setTextColor(59, 78, 135);
      doc.text("PURCHASE ORDER", centerTextX, textYOffset + 8, {
        align: "center",
      });
      // Reset color
      doc.setTextColor(0, 0, 0);

      // ✅ Date label
      doc.setFontSize(9);
      doc.setFont("TimesNewRoman", "normal");
      doc.text("DATE", boxLabelX, textYOffset + 14);

      // ✅ Date box + centered text
      const dateValue = new Date(orderDate).toLocaleDateString("id-ID", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });

      const boxY = textYOffset + 9;
      doc.setDrawColor(150, 150, 150);
      doc.setLineWidth(0.2);
      doc.rect(boxValueX, boxY, boxWidth, boxHeight);

      // Center date text
      const dateTextWidth = doc.getTextWidth(dateValue);
      const dateTextX = boxValueX + (boxWidth - dateTextWidth) / 2;
      doc.text(dateValue, dateTextX, boxY + 4);

      // ✅ PO# label
      doc.text("PO#", boxLabelX + 2, textYOffset + 22);

      // ✅ PO# box + centered text
      const poBoxY = textYOffset + 17;
      doc.rect(boxValueX, poBoxY, boxWidth, boxHeight);
      const alamatLines = [
        "Kompleks Kementerian Pertanian",
        "Jl Harsono RM No.3 Gedung E",
        "Ragunan, Ps. Minggu, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12550",
      ];
      const linkBgn = "https://www.bgn.go.id/";
      const textWidthLinkBgn = doc.getTextWidth(linkBgn);
      const poTextWidth = doc.getTextWidth(orderNumber);
      const poTextX = boxValueX + (boxWidth - poTextWidth) / 2;
      doc.text(orderNumber, poTextX, poBoxY + 4);
      // Starting X and Y for the column
      const startX = LEFT_MARGIN;
      let startY = 39;

      // Loop through the lines and print them in a column
      alamatLines.forEach((line) => {
        doc.setFontSize(8);
        doc.text(line, startX, startY);
        startY += 4; // move down for the next line
      });

      // Draw link on top
      doc.setTextColor(0, 120, 255);
      doc.textWithLink(linkBgn, startX, startY, { url: linkBgn });

      // Underline
      doc.setDrawColor(0, 120, 255);
      doc.line(startX, startY + 1, startX + textWidthLinkBgn - 3.5, startY + 1);

      // Reset color
      doc.setTextColor(250, 250, 250);

      // Row layout
      const margin = 20;
      const rowHeight = 8;
      const colWidth = (pageWidth - (LEFT_MARGIN + RIGHT_MARGIN)) / 2; // Two equal columns
      const startYVendor = startY + 5; //

      // ✅ Draw background for Vendor (left column)
      doc.setFillColor(59, 78, 135); // Light blue
      doc.rect(LEFT_MARGIN, startYVendor, colWidth, rowHeight, "F");

      // ✅ Draw background for Ship To (right column)
      doc.rect(
        LEFT_MARGIN + colWidth + margin,
        startYVendor,
        colWidth - 5,
        rowHeight,
        "F",
      );

      // Reset color
      // ✅ Add Vendor text (left-aligned)
      doc.setFontSize(9);
      doc.setTextColor(255, 255, 255);
      doc.setFont("TimesNewRoman", "bold");
      doc.text("VENDOR", LEFT_MARGIN + RECT_PADDING, startYVendor + 5);

      // ✅ Add Ship To text (left-aligned)
      doc.text(
        "SHIP TO",
        LEFT_MARGIN + colWidth + margin + RECT_PADDING,
        startYVendor + 5,
      );

      // Reset color
      doc.setTextColor(0, 0, 0);
      doc.setFont("TimesNewRoman", "normal");

      // Vendor dummy text
      const vendorText = [`${supplierName}`];

      // Ship To dummy text
      const shipToText = [`${receiverName}`];

      // Receiver address text
      const receiverAddressText = [`${receiverAddress}`]; // Convert the receiver address to an array to wrap text

      let textYVendor = startYVendor + rowHeight + 5;
      let textYShipTo = startYVendor + rowHeight + 5;
      let textYReceiverAddress = textYShipTo + 5; // Set Y position for receiver address

      // ✅ Wrap vendor text to fit column width
      vendorText.forEach((line) => {
        const wrappedLines = doc.splitTextToSize(line, colWidth - 5); // wrap inside 50% width
        wrappedLines.forEach((l) => {
          doc.text(l, LEFT_MARGIN + RECT_PADDING, textYVendor);
          textYVendor += 5;
        });
      });

      // ✅ Wrap ship-to text to fit column width
      shipToText.forEach((line) => {
        const wrappedLines = doc.splitTextToSize(line, colWidth - 5);
        wrappedLines.forEach((l) => {
          doc.text(
            l,
            LEFT_MARGIN + colWidth + margin + RECT_PADDING,
            textYShipTo,
          );
          textYShipTo += 5;
        });
      });

      // ✅ Wrap receiver address text to fit column width (under ship-to)
      receiverAddressText.forEach((line) => {
        const wrappedLines = doc.splitTextToSize(line, colWidth - 5);
        wrappedLines.forEach((l) => {
          doc.setFontSize(8);
          doc.text(
            l,
            LEFT_MARGIN + colWidth + margin + RECT_PADDING,
            textYReceiverAddress,
          );
          textYReceiverAddress += 5;
        });
      });
      // ✅ Supplier Info (COMMENTED OUT)
      /*
    const supplierInfo = {
      Pemasok: supplierName,
      Nomor: orderNumber,
      'Tanggal': dateValue,
      Penerima: receiverName,
    };
    */
    };

    let yOffset = 90;
    const totalPageHeight = doc.internal.pageSize.height;
    let pageNumber = 1;

    const addFooter = (currentPage, totalPages) => {
      const footerText = `Page ${currentPage} of ${totalPages}`;
      doc.setFontSize(10);
      doc.text(
        footerText,
        pageWidth - doc.getTextWidth(footerText) - 10,
        totalPageHeight - 10,
      );
    };

    addHeader(
      doc,
      pageWidth,
      supplierName,
      orderNumber,
      orderDate,
      receiverName,
      iconBase64,
    );

    // Initialize grand total
    let grandTotal = 0;

    // Loop through order details
    Object.entries(orderDetails).forEach(([deliveryDate, items], index) => {
      const sectionHeight = items.length * 5 + 26;

      // Check for page break
      if (yOffset + sectionHeight > totalPageHeight - 20) {
        doc.addPage();
        yOffset = 40;
        pageNumber += 1;
        addHeader(
          doc,
          pageWidth,
          supplierName,
          orderNumber,
          orderDate,
          receiverName,
          iconBase64,
        );
      }

      // Calculate section subtotal
      const sectionSubtotal = items.reduce(
        (sum, item) => sum + (parseFloat(item.price_total) || 0),
        0,
      );
      grandTotal += sectionSubtotal; // Add to grand total

      // Draw gray border for the section
      // doc.setDrawColor(200, 200, 200);
      // doc.rect(10, yOffset, pageWidth - 20, sectionHeight, 'S');

      // Add delivery date
      doc.setFontSize(10);
      // doc.text(
      //   `Tanggal Pengiriman: ${new Date(deliveryDate).toLocaleDateString('id-ID', {
      //     year: 'numeric',
      //     month: 'long',
      //     day: '2-digit',
      //   })}`,
      //   15,
      //   yOffset + 5
      // );

      //yOffset += 7;

      // Add table for items
      doc.autoTable({
        theme: "grid", // This adds borders to all cells
        margin: { left: 20, right: 10 }, // Same left margin as iconX
        tableWidth: pageWidth - 25, // total width minus margins
        startY: yOffset,
        head: [
          [
            "NO",
            "ITEM",
            "QTY",
            "SATUAN",
            "UNIT PRICE",
            "TOTAL",
            // , 'Diterima Supir', 'Diterima Dapur'
          ],
        ],
        body: items.map((item, index) => [
          `${index + 1}`,
          item.ingredient_name || "-",
          formatNumber(item.order_qty), // Formatted
          item.uoq_code || "-",
          formatNumber(item.price_unit) || "-", // Formatted
          formatNumber(item.price_total) || "-", // Formatted,
          // '[   ]',
          // '[   ]',
        ]),
        columnStyles: {
          0: { halign: "center", cellWidth: "6%" },
          1: { halign: "left", cellWidth: 90 },
          2: { halign: "center", cellWidth: "20%" },
          3: { halign: "center", cellWidth: "10%" },
          4: { halign: "right", cellWidth: "10%" },
          5: { halign: "right", cellWidth: "15%", fillColor: [240, 240, 240] }, // ✅ Light Grey Background},
          // 6: { halign: 'center', cellWidth: '5%' },
          // 7: { halign: 'center', cellWidth: '5%' },
        },
        didParseCell: function (data) {
          // ✅ Force all header cells to be centered
          if (data.section === "head") {
            data.cell.styles.halign = "center";
          }
        },
        styles: {
          cellPadding: 1,
          fontSize: 8,
          overflow: "linebreak",
          font: "TimesNewRoman",
          lineWidth: 0.2, // border thickness
          lineColor: [0, 0, 0], // border color (black)
          textColor: [0, 0, 0],
        },
        headStyles: {
          fontSize: 9,
          fontStyle: "bold", // ✅ Make header bold
          fillColor: [59, 78, 135],
          textColor: [255, 255, 255],
          lineWidth: 0.3, // thicker border for header
          lineColor: [0, 0, 0],
        },
      });

      // Update yOffset for next section
      yOffset = doc.lastAutoTable.finalY + 5;

      doc.setFontSize(8);
      // Get table info// Calculate values
      const subtotalValue = sectionSubtotal; // from your loop
      const ppn = 0; // 10%
      const ppnValue = subtotalValue * (ppn / 100); // ✅                // 10% of subtotal
      const totalValue = subtotalValue + ppnValue; // subtotal + ppn

      // Format values
      const subtotalText = formatNumber(subtotalValue);
      const ppnText = formatNumber(ppnValue);
      const totalText = formatNumber(totalValue);
      const table = doc.lastAutoTable; // get last autoTable instance
      const tableEndY = table.finalY - 1.8; // Y position after the table
      const lastColumn = table.columns[table.columns.length - 1]; // last column
      const lastRow = table.body[table.body.length - 1];
      // Get the last cell in that row
      const lastCell = lastRow.cells[Object.keys(lastRow.cells).pop()];

      // Now you have:
      const lastColumnX = lastCell.x;
      const lastColumnWidth = lastColumn.width; // width of last column

      console.log({
        tableEndY,
        lastColumn,
        lastColumnX,
        lastColumnWidth,
      });

      // Draw border box for TOTAL
      const boxHeight = 6;
      doc.setDrawColor(150, 150, 150); // grey border
      doc.setLineWidth(0.2);

      // Add text centered inside the box
      const textWidth = doc.getTextWidth(totalText);
      const textX = lastColumnX + (lastColumnWidth - textWidth) / 2;

      //SUBTOTAL
      const paddingLeft = 2; // for values

      // Calculate right-aligned X for values
      const subtotalX =
        lastColumnX + lastColumnWidth - doc.getTextWidth(subtotalText) - 2; // 2px padding
      const ppnX =
        lastColumnX + lastColumnWidth - doc.getTextWidth(ppnText) - 2;
      const totalX =
        lastColumnX + lastColumnWidth - doc.getTextWidth(totalText) - 2;

      // SUBTOTAL
      doc.setFillColor(240, 240, 240);
      doc.rect(lastColumnX, tableEndY + 2, lastColumnWidth, boxHeight, "F");
      doc.setFont("TimesNewRoman", "bold");
      doc.text(subtotalText, subtotalX, tableEndY + 6); // ✅ right-aligned value
      doc.setFont("TimesNewRoman", "normal");
      doc.text("SUBTOTAL", lastColumnX - lastColumnWidth - 5, tableEndY + 6);

      // PPn (%)
      doc.rect(lastColumnX, tableEndY + 8, lastColumnWidth, boxHeight);
      doc.text(ppnText, ppnX, tableEndY + 12); // ✅ right-aligned value
      doc.setFont("TimesNewRoman", "normal");
      doc.text(
        `PPn (${ppn}%)`,
        lastColumnX - lastColumnWidth - 5,
        tableEndY + 12,
      );

      // TOTAL
      doc.setFillColor(167, 179, 216);
      doc.rect(lastColumnX, tableEndY + 14, lastColumnWidth, boxHeight, "F");

      // Draw only the top border
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.2);
      doc.line(
        lastColumnX,
        tableEndY + 14,
        lastColumnX + lastColumnWidth,
        tableEndY + 14,
      );

      doc.setFont("TimesNewRoman", "bold");
      doc.text(totalText, totalX, tableEndY + 18); // ✅ right-aligned value
      doc.text("TOTAL", lastColumnX - lastColumnWidth - 5, tableEndY + 18);

      console.log(table); // see structure
      // Set font size to 8 for subtotal
      doc.setFontSize(8);
      //doc.text(pageWidth - 60, yOffset)
      // doc.text(`Total :   ${formatNumber(sectionSubtotal)}`, pageWidth - 25 -(String(formatNumber(sectionSubtotal)).length), yOffset);
      yOffset += 15; // Adjust yOffset for next section
    });

    // Display grand total
    // doc.text(`Grand Total:`, pageWidth - 64 , yOffset)
    // doc.text(`${formatNumber(grandTotal)}`, pageWidth - 20 -(String(formatNumber(grandTotal)).length), yOffset);

    // Signature block aligned with table right edge
    const sectionWidth = 60;
    const startX = pageWidth + 7 - sectionWidth; // align to table's right edge
    const jabatan = `${position}`;
    doc.setFont("TimesNewRoman", "normal");
    doc.setFontSize(10);

    // Header text
    doc.text("Disetujui oleh,", startX - 3, yOffset + 7, { align: "left" });

    // Set font size for the rest of the text
    doc.setFontSize(9);

    // picName text
    // doc.text(`${picName}`, startX, yOffset + 25, { align: "left" });

    // Wrap jabatan text to fit within the specified width
    const wrappedJabatan = doc.splitTextToSize(jabatan, 40); // 100 is the max width for the text to fit
    wrappedJabatan.forEach((line, index) => {
      doc.text(line, startX - 3, yOffset + 45 + index * 5); // Increase yOffset for each line
    });
    // Note width = 1/3 of page
    const sectionWidthNote = pageWidth / 3;
    const headerHeight = 10;
    const startXNote = pageWidth - 120 - sectionWidthNote;
    const startYNote = yOffset - 15;

    // ✅ Prepare wrapped text
    doc.setFontSize(9);
    const noteTextFromApi = await getNoteByOrderId(orderId);
    const noteText =
      noteTextFromApi && noteTextFromApi.trim() ? noteTextFromApi : "-";
    const wrappedText = doc.splitTextToSize(noteText, sectionWidthNote - 10); // wrap text
    const lineHeight = 5; // spacing between lines
    const textHeight = wrappedText.length * lineHeight;

    // ✅ Final box height = header + text + some padding
    const sectionHeightNote = headerHeight + textHeight + 5;

    // Heights
    const labelHeight = 10;
    const valueHeight = sectionHeightNote - labelHeight;

    // ✅ Top label box (gray border)
    doc.setDrawColor(150, 150, 150); // gray
    doc.setLineWidth(0.2);
    doc.setFillColor(220, 220, 220); // light gray fill
    doc.rect(startXNote, startYNote, sectionWidthNote, labelHeight, "FD"); // filled + border

    // ✅ Add "Note" label text
    doc.setFontSize(10);
    doc.setFont("TimesNewRoman", "bold");
    doc.setTextColor(0, 0, 0); // black text
    doc.text("Note", startXNote + 10, startYNote + 7); // slight top padding

    // ✅ Bottom value box (black border)
    doc.setDrawColor(0, 0, 0); // black
    doc.setLineWidth(0.2);
    doc.setFillColor(255, 255, 255); // white fill
    const valueY = startYNote + labelHeight;
    doc.rect(startXNote, valueY, sectionWidthNote, valueHeight, "FD");

    // ✅ Add wrapped note text
    doc.setFontSize(9);
    doc.setFont("TimesNewRoman", "normal");
    doc.text(wrappedText, startXNote + 5, valueY + 6, {
      maxWidth: sectionWidthNote - 10,
    });

    const pageCount = doc.internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addFooter(i, pageCount);
    }
    const cleanSupplierName = (supplierName) => {
      return supplierName
        .replace(/\b(PT|CV|PD)\b\s*/gi, "")
        .trim()
        .replace(/\s+/g, "_");
    };

    doc.save(`${cleanSupplierName(supplierName)}_${orderNumber}.pdf`);
    await new Promise((resolve) => setTimeout(resolve, 1000)); // 500ms delay
  };

  // Group the filtered data by Order Number and Delivery Date
  const groupedData = groupDataByOrderNumberAndDeliveryDate(filteredData);
  const sortedGroupedData = sortGroupedDataByDate(groupedData); // Sort the grouped data

  // const CustomInput = React.forwardRef(({ onClick, isOpen }, ref) => (
  //   <button
  //     className="flex items-center justify-between w-full px-4 py-2 border-none rounded-[15px] bg-white"
  //     onClick={onClick}
  //     ref={ref}
  //     type="button"
  //   >
  //     <div className="flex items-center gap-2">
  //       <img src={CalendarIcon} alt="Calendar" className="h-5 w-5 text-gray-500" />
  //       <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
  //       <span>
  //         {new Date(selectedDate).toLocaleDateString("id-ID", {
  //           year: "numeric",
  //           month: "long",
  //           day: "2-digit",
  //         })}
  //       </span>
  //     </div>
  //     <div
  //       className={`text-black font-semibold transform transition-transform duration-500 ease-in-out ps-4 ${isOpen ? "rotate-180" : "rotate-0"}`}
  //     >
  //       ▼
  //     </div>
  //   </button>
  // ));

  // useEffect(() => {
  //   const getNextMonday = () => {
  //     const currentDate = new Date();
  //     const dayOfWeek = currentDate.getDay();
  //     const daysUntilNextMonday = (8 - dayOfWeek) % 7;
  //     currentDate.setDate(currentDate.getDate() + daysUntilNextMonday);
  //     currentDate.setHours(0, 0, 0, 0);

  //     return currentDate;
  //   };

  // If roleId is 2, set selected date to next Monday, else this week's Monday
  //setSelectedDate(roleId === 2 ? getNextMonday() : new Date());
  // }, [roleId]);
  const [modalData, setModalData] = useState(null); // Store the modal data for the note
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [text, setText] = useState(""); // Store the textarea content

  const [loadingNote, setLoadingNote] = useState(true);

  const [modalOrderId, setModalOrderId] = useState(null);

  const openModal = (orderId) => {
    setModalOrderId(orderId);
    setIsModalOpen(true);
    setLoadingNote(true);
    fetchInitialNote(orderId);
  };

  const fetchInitialNote = async (orderId) => {
    try {
      const res = await instance2.get(`/order_note/${orderId}`);
      // Try the common shapes; adjust based on your actual payload
      const note = res?.data[0]?.note ?? res?.data?.data[0]?.note ?? ""; // fallback empty string

      setText(note);
    } catch (err) {
      console.error("Error fetching note:", err);
      setText("");
    } finally {
      setLoadingNote(false);
    }
  };

  // Handle saving the note (PUT request)
  const handleSave = async (orderId) => {
    try {
      const res = await instance2.put(`/order_note/${orderId}`, {
        admin_id: userAuthentication,
        note: text,
      });

      const ok = res.status === "OK" || res?.data?.status === "OK";
      if (ok) {
        //alert("Note saved successfully!");
        setIsModalOpen(false);
      } else {
        alert("Failed to save note");
      }
    } catch (err) {
      console.error("Error saving note:", err);
      alert("Failed to save note");
    }
  };

  const getNoteByOrderId = async (orderId) => {
    try {
      const res = await instance2.get(`/order_note/${orderId}`);
      const note =
        // array at top level
        res?.data?.[0]?.note ??
        // array inside data
        res?.data?.data?.[0]?.note ??
        // object at top level
        res?.data?.note ??
        // object inside data
        res?.data?.data?.note ??
        "";
      return note ?? "";
    } catch (e) {
      console.error("Failed to fetch note for PDF:", e);
      return "";
    }
  };

  const handleCancelOrder = async (orderId) => {
    try {
      const response = await instance2.post(`/cancel_order/${orderId}`);
      console.log("Order cancelled:", response.data);
      toast.success("Purchase Order berhasil dibatalkan");
      // Refresh data or any other action here
    } catch (error) {
      console.error("Error cancelling order:", error);
      toast.error("Gagal membatalkan Purchase Order");
    }
  };

  // confirmation dialog state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [orderIdToCancel, setOrderIdToCancel] = useState(null);
  const [isCancelling, setIsCancelling] = useState(false);

  const openConfirmCancel = (orderId) => {
    setOrderIdToCancel(orderId);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    setConfirmOpen(false);
    setOrderIdToCancel(null);
  };

  const confirmCancelNow = async () => {
    if (!orderIdToCancel) return;
    try {
      setIsCancelling(true);
      await handleCancelOrder(orderIdToCancel); // your existing API call
      closeConfirm();
      navigate(`/draftOrder/`);
    } finally {
      setIsCancelling(false);
    }
  };

  const handleSaveOrderNo = async () => {
    const next = (orderNoInput || "").trim();
    setSavingOrderNo(true);
    setOrderNoError("");

    try {
      const res = await instance2.post(`/change_order_no/${editOrderId}`, {
        order_no: next,
        admin_id: adminId,
      });

      if (res?.status === 200 || res?.status === "OK") {
        setIsEditOrderOpen(false);
        setIsConfirmOpen(false);
        if (typeof fetchData === "function") fetchData();
      } else {
        setOrderNoError("Gagal menyimpan nomor PO.");
      }
    } catch (err) {
      console.error(err);
      setOrderNoError(
        err?.response?.data?.message || "Terjadi kesalahan saat menyimpan.",
      );
    } finally {
      setSavingOrderNo(false);
    }
  };

  return (
    <div className="p-4">
      {/*
    <div>
      <h1>Daftar Pemesanan</h1>
      <p>Start Date: {startDate}</p>
      <p>End Date: {endDate}</p>
    </div> */}

      {/* Header */}
      <div className="flex flex-row w-full justify-between items-center">
        <div className="flex flex-col w-full">
          <p className="block text-black text-xl sm:text-2xl my-2 font-medium">
            Purchase Order
          </p>
          <div className="pb-4">
            {(() => {
              //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
              return (
                `${new Date(startDate).toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })} ` +
                `${
                  startDate !== endDate
                    ? "- " +
                      new Date(endDate).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      })
                    : ""
                }`
              );
            })()}
          </div>
          <div className="border-t border-gray-400 w-full flex-1"></div>
          <div className="flex flex-col md:flex-col lg:flex-row items-start gap-4 justify-between w-full py-5">
            {/*<div className="flex flex-row items-center gap-4 py-4">
              <div className="text-md">Tanggal</div>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="yyyy-MM-dd"
                onCalendarOpen={() => setIsOpen(true)}
                onCalendarClose={() => setIsOpen(false)}
                customInput={<CustomInput isOpen={isOpen} />}
              />
            </div> */}
            <div className="flex gap-4 items-center">
              <label className=" text-xxs md:text-xxs lg:text-base text-black">
                Nama Pemasok
              </label>
              <select
                value={sortSupplier}
                onChange={(e) => setSortSupplier(e.target.value)}
                className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
              >
                <option value="">Semua</option>
                {[...new Set(data.map((item) => item.supplier_name))].map(
                  (supplier, index) => (
                    <option key={index} value={supplier}>
                      {supplier}
                    </option>
                  ),
                )}
              </select>
            </div>

            {kitchenId ? (
              ""
            ) : (
              <div className="flex gap-4 items-center">
                <label className=" text-xxs md:text-xxs lg:text-base text-black">
                  Nama Dapur
                </label>
                <select
                  value={sortKitchen}
                  onChange={(e) => setSortKitchen(e.target.value)}
                  className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
                >
                  <option value="">Semua</option>
                  {[...new Set(data.map((item) => item.kitchen_name))].map(
                    (kitchen, index) => (
                      <option key={index} value={kitchen}>
                        {kitchen}
                      </option>
                    ),
                  )}
                </select>
              </div>
            )}
            {/* <div className="flex gap-4 items-center">
              <label className="text-md text-black">Nama Bahan</label>
              <select
                value={sortIngredient}
                onChange={(e) => setSortIngredient(e.target.value)}
                className="px-4 py-2 border-transparent rounded-[25px]"
              >
                <option value="">All</option>
                {[...new Set(data.map((item) => item.ingredient_name))].map(
                  (ingredient, index) => (
                    <option key={index} value={ingredient}>
                      {ingredient}
                    </option>
                  )
                )}
              </select>
            </div> */}
            {/* take out by deden */}
            {/* {roleId !== 3 ? (
              <div className="flex gap-4 items-center">
                <label className=" text-xxs md:text-xxs lg:text-base text-black">
                  Tanggal
                </label>
                <select
                  value={sortDate}
                  onChange={(e) => setSortDate(e.target.value)}
                  className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
                >
                  <option value="">Semua</option>
                  {[...new Set(data.map((item) => item.delivery_date))].map(
                    (date, index) => (
                      <option key={index} value={date}>
                        {new Date(date).toLocaleDateString("id-ID", {
                          year: "numeric",
                          month: "long",
                          day: "2-digit",
                        })}
                      </option>
                    ),
                  )}
                </select>
              </div>
            ) : (
              ""
            )} */}

            {roleId === 2 || roleId === 3 ? (
              // || roleId === 4 || roleId === 5
              <div>
                {/* <button
                type="button"
                onClick={handlePenerimaan}
                className={receivedExist!=0 ? "w-1/8 px-8 py-4 text-white rounded-[50px] mx-4 bg-merah-no hover:bg-merah-hover uppercase text-xxs md:text-xxs lg:text-base":
                  "w-1/8 px-8 py-4 text-white rounded-[50px] mx-4 bg-gray-200 uppercase text-xxs md:text-xxs lg:text-base"}
                disabled = {receivedExist===0 }
              >
              LIHAT PENERIMAAN BAHAN
           </button> */}
                <button
                  type="button"
                  onClick={handlePenerimaan}
                  className="w-1/8 px-8 py-4 text-white rounded-[50px] bg-merah-no hover:bg-merah-hover uppercase text-xxs md:text-xxs lg:text-base"
                  // className={receivedExist===0  ? "w-1/8 px-8 py-4 text-white rounded-[50px] bg-merah-no hover:bg-merah-hover uppercase text-xxs md:text-xxs lg:text-base":
                  //   "w-1/8 px-8 py-4 text-white rounded-[50px] bg-gray-200 uppercase text-xxs md:text-xxs lg:text-base"}
                  //disabled = {receivedExist!=0 }
                >
                  PENERIMAAN BAHAN
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="border-t border-gray-400 w-full flex-1"></div>
        </div>
      </div>

      {/* Table Data */}

      <div className="mt-8">
        <div className="flex gap-4">
          {roleId === 5 && (
            <button
              className="px-4 py-2 bg-red-500 text-white rounded mb-6 text-sm"
              onClick={() => openConfirmCancel(startDate)}
            >
              Batalkan Purchase Order
            </button>
          )}
          {!loading && !error && roleId !== 3 && (
            <button
              className="px-4 py-2 bg-oren-no hover:bg-oren-hover text-white rounded mb-6 text-sm"
              onClick={async () => {
                for (const [orderNumber, orderDetails] of Object.entries(
                  sortedGroupedData,
                )) {
                  const supplierName =
                    orderDetails[Object.keys(orderDetails)[0]][0].supplier_name;
                  const receiverName =
                    orderDetails[Object.keys(orderDetails)[0]][0].kitchen_name;
                  const orderDate = localDateString(
                    new Date(
                      orderDetails[Object.keys(orderDetails)[0]][0].date,
                    ),
                  );

                  // Generate a unique file name
                  const fileName = `Order_${orderNumber}_${supplierName}_${orderDate}.pdf`;

                  // Wait for each PDF to finish saving with a delay
                  await handleDownloadPDF(
                    orderNumber,
                    orderDetails,
                    supplierName,
                    orderDate,
                    receiverName,
                    orderDetails[Object.keys(orderDetails)[0]][0].order_id,
                  );
                }
              }}
            >
              Download Semua PDF
            </button>
          )}
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="text-red-500">{error}</p>}
        {!loading && !error && Object.keys(sortedGroupedData).length === 0 && (
          <p>No data available</p>
        )}

        {/* ✅ Desktop / Tablet */}
        <div className="hidden sm:block">
          {Object.entries(sortedGroupedData).map(
            ([orderNumber, orderDetails], index) => (
              <div
                key={orderNumber}
                className={`mb-10 p-4 rounded-[15px] shadow-md w-full
        ${index % 2 === 0 ? "bg-white" : "bg-[#F2DBB5]"}
        flex flex-col gap-1
      `}
              >
                {/* Header Info */}
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between justify-center gap-1">
                  <div className="flex flex-col items-center sm:items-start gap-1">
                    <h3 className="text-base lg:text-lg font-semibold">
                      {index + 1}. Dapur:{" "}
                      {
                        orderDetails[Object.keys(orderDetails)[0]][0]
                          .kitchen_name
                      }
                    </h3>
                    <h3 className="text-base lg:text-lg font-semibold">
                      Pemasok:{" "}
                      {
                        orderDetails[Object.keys(orderDetails)[0]][0]
                          .supplier_name
                      }
                    </h3>
                    <div
                      className="flex items-center gap-2 cursor-pointer"
                      onClick={() =>
                        openEditOrderDialog(
                          orderDetails[Object.keys(orderDetails)[0]][0]
                            .order_id,
                          orderNumber,
                        )
                      }
                    >
                      <h3 className="text-base lg:text-lg font-semibold">
                        {orderNumber}
                      </h3>
                      <EditIcon />
                    </div>
                  </div>
                  <div className="flex flex-col items-center sm:items-start gap-1">
                    <div className="flex flex-col sm:flex-row items-center gap-1">
                      {orderDetails[Object.keys(orderDetails)[0]][0]
                        .received_po > 0 ? (
                        <div className="flex items-center text-green-500 text-sm font-semibold">
                          <ListOn className="w-5 h-5 mr-2" />
                          Bahan Sudah Diterima
                        </div>
                      ) : (
                        <div className="text-red-500 text-sm font-semibold">
                          Bahan Belum Diterima
                        </div>
                      )}
                      {roleId !== 3 && (
                        <button
                          className="px-4 py-2 bg-blue-500 text-white rounded-md text-sm bg-oren-no hover:bg-oren-hover"
                          onClick={() =>
                            handleDownloadPDF(
                              orderNumber,
                              orderDetails,
                              orderDetails[Object.keys(orderDetails)[0]][0]
                                .supplier_name,
                              localDateString(
                                new Date(
                                  orderDetails[
                                    Object.keys(orderDetails)[0]
                                  ][0].date,
                                ),
                              ),
                              orderDetails[Object.keys(orderDetails)[0]][0]
                                .kitchen_name,
                              orderDetails[Object.keys(orderDetails)[0]][0]
                                .order_id,
                            )
                          }
                        >
                          Download PDF
                        </button>
                      )}
                    </div>
                    {roleId === 5 && (
                      <button
                        onClick={() =>
                          openModal(
                            orderDetails[Object.keys(orderDetails)[0]][0]
                              .order_id,
                          )
                        }
                        className="bg-merah-no hover:bg-merah-hover text-white px-4 py-2 rounded-md w-full text-center"
                      >
                        Catatan
                      </button>
                    )}
                  </div>
                </div>

                <div className="mt-2 space-y-6">
                  {Object.entries(orderDetails).map(
                    ([deliveryDate, items], innerIndex) => (
                      <div
                        key={deliveryDate}
                        className="rounded-md p-4"
                        style={{
                          backgroundColor: generateGreyColor(innerIndex),
                        }}
                      >
                        <h4 className="font-semibold mb-2">
                          Tanggal Pengiriman:{" "}
                          {new Date(deliveryDate).toLocaleDateString("id-ID", {
                            year: "numeric",
                            month: "long",
                            day: "2-digit",
                          })}
                        </h4>

                        {/* Table for medium/large screen */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm">
                            <thead>
                              <tr className="bg-white">
                                <th
                                  className="border-b px-4 py-2 text-left rounded-tl-[10px]"
                                  style={{ width: "50px" }}
                                >
                                  No.
                                </th>
                                <th className="border-b px-4 py-2 text-left">
                                  Bahan Baku
                                </th>
                                <th
                                  className="border-b px-6 py-2 text-center"
                                  colSpan={2}
                                >
                                  Jumlah
                                </th>
                                {roleId !== 3 && (
                                  <th className="border-b px-6 py-2 text-right">
                                    Harga/Unit
                                  </th>
                                )}
                                {roleId !== 3 && (
                                  <th className="border-b px-6 py-2 text-right rounded-tr-[10px]">
                                    Subtotal
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((item, idx) => (
                                <tr
                                  key={idx}
                                  className="border-b odd:bg-transparent even:bg-white"
                                >
                                  <td className="px-4 py-2 text-right">
                                    {idx + 1}.
                                  </td>
                                  <td className="px-4 py-2">
                                    {item.ingredient_name || "-"}
                                  </td>
                                  <td className="ps-6 py-2 text-right">
                                    {formatNumber(item.order_qty)}
                                  </td>
                                  <td className="px-4 py-2 text-left">
                                    {item.uoq_code || "-"}
                                  </td>

                                  {roleId !== 3 && (
                                    <td className="px-6 py-2 text-right">
                                      {formatNumber(item.price_unit) || "-"}
                                    </td>
                                  )}
                                  {roleId !== 3 && (
                                    <td className="px-6 py-2 text-right">
                                      {formatNumber(item.price_total) || "-"}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>

                            {roleId !== 3 && (
                              <tfoot>
                                <tr>
                                  {/* merge kolom lain pakai colSpan agar total rata kanan */}
                                  <td colSpan={4} />
                                  <td className="text-right">Total</td>
                                  <td className="px-6 py-2 text-right font-bold">
                                    {formatNumber(
                                      items.reduce(
                                        (sum, item) =>
                                          sum +
                                          (parseInt(item.price_total, 10) || 0),
                                        0,
                                      ),
                                    )}
                                  </td>
                                </tr>
                              </tfoot>
                            )}
                          </table>
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            ),
          )}
        </div>

        {/* ✅ Mobile Swiper version */}
        <div className="block sm:hidden">
          {/* Swiper Arrows */}
          <Button
            variant="outline"
            size="icon"
            className="fixed top-1/2 left-4 z-[50] -translate-y-1/2 swiper-prev"
          >
            <ChevronLeft size={24} />
          </Button>

          <Button
            variant="outline"
            size="icon"
            className="fixed top-1/2 right-4 z-[50] -translate-y-1/2 swiper-next"
          >
            <ChevronRight size={24} />
          </Button>
          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            loop={false}
            pagination={{
              clickable: true,
              renderBullet: function (index, className) {
                return `<span class="!size-6 !text-sm !rounded-full !aspect-square !bg-white !border !border-gray-300 ${className}">${index + 1}</span>`;
              },
            }}
            navigation={{ nextEl: ".swiper-next", prevEl: ".swiper-prev" }}
            modules={[Pagination, Navigation]}
            className="max-w-full [&_.swiper-pagination]:w-fit [&_.swiper-pagination]:text-balance [&_.swiper-pagination]:space-y-2 [&_.swiper-pagination]:space-x-2 [&_.swiper-pagination]:lg:hidden [&_.swiper-slide]:mb-16 [&_.swiper-slide]:lg:mb-0"
          >
            {Object.entries(sortedGroupedData).map(
              ([orderNumber, orderDetails], index) => (
                <SwiperSlide key={orderNumber}>
                  <div
                    className={`p-4 rounded-[15px] shadow-md w-full
            ${index % 2 === 0 ? "bg-white" : "bg-[#F2DBB5]"}
            flex flex-col gap-4
          `}
                  >
                    {/* Header Info */}
                    <div className="flex flex-col items-center gap-2 text-center">
                      <h3 className="text-base font-bold">
                        {index + 1}. Dapur:{" "}
                        {
                          orderDetails[Object.keys(orderDetails)[0]][0]
                            .kitchen_name
                        }
                      </h3>
                      <h3 className="text-base font-semibold">
                        Pemasok:{" "}
                        {
                          orderDetails[Object.keys(orderDetails)[0]][0]
                            .supplier_name
                        }
                      </h3>
                      <div
                        className="flex items-center gap-2 cursor-pointer"
                        onClick={() =>
                          openEditOrderDialog(
                            orderDetails[Object.keys(orderDetails)[0]][0]
                              .order_id,
                            orderNumber,
                          )
                        }
                      >
                        <h3 className="text-base lg:text-lg font-semibold">
                          {orderNumber}
                        </h3>
                        <EditIcon />
                      </div>

                      {/* ✅ Status & Button */}
                      {orderDetails[Object.keys(orderDetails)[0]][0]
                        .received_po > 0 ? (
                        <div className="text-green-500 text-sm font-semibold mt-2">
                          Bahan Sudah Diterima
                        </div>
                      ) : (
                        <div className="text-red-500 text-sm font-semibold mt-2">
                          Bahan Belum Diterima
                        </div>
                      )}
                      <button
                        className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-md text-sm bg-oren-no hover:bg-oren-hover"
                        onClick={() =>
                          handleDownloadPDF(
                            orderNumber,
                            orderDetails,
                            orderDetails[Object.keys(orderDetails)[0]][0]
                              .supplier_name,
                            localDateString(
                              new Date(
                                orderDetails[
                                  Object.keys(orderDetails)[0]
                                ][0].date,
                              ),
                            ),
                            orderDetails[Object.keys(orderDetails)[0]][0]
                              .kitchen_name,
                            orderDetails[Object.keys(orderDetails)[0]][0]
                              .order_id,
                          )
                        }
                      >
                        Download PDF
                      </button>
                      <button
                        onClick={() =>
                          openModal(
                            orderDetails[Object.keys(orderDetails)[0]][0]
                              .order_id,
                          )
                        }
                        className="bg-merah-no hover:bg-merah-hover mt-2 px-4 py-2 bg-blue-500 text-white rounded-md text-sm"
                      >
                        Catatan
                      </button>
                    </div>

                    {/* Deliveries */}
                    <div className="mt-6 space-y-4">
                      {Object.entries(orderDetails).map(
                        ([deliveryDate, items], innerIndex) => (
                          <div
                            key={deliveryDate}
                            className="bg-gray-100 p-4 rounded-md"
                          >
                            <h4 className="font-bold mb-2">
                              Tanggal:{" "}
                              {new Date(deliveryDate).toLocaleDateString(
                                "id-ID",
                                {
                                  year: "numeric",
                                  month: "long",
                                  day: "2-digit",
                                },
                              )}
                            </h4>

                            {/* Items in Card */}
                            <div className="space-y-2">
                              {items.map((item, idx) => (
                                <div
                                  key={idx}
                                  className="flex flex-col bg-white p-3 rounded-md shadow-sm"
                                >
                                  <div className="font-semibold text-sm">
                                    {idx + 1}. {item.ingredient_name}
                                  </div>
                                  <div className="flex flex-row w-full justify-between mt-2">
                                    <div className="text-xs text-gray-700">
                                      Jumlah: {formatNumber(item.order_qty)}{" "}
                                      {item.uoq_code}
                                    </div>
                                    <div className="text-xs text-gray-600">
                                      Harga/Unit: Rp{" "}
                                      {formatNumber(item.price_unit) || "-"}
                                    </div>
                                  </div>
                                  <div className="text-xs font-medium mt-4">
                                    Subtotal: Rp{" "}
                                    {formatNumber(item.price_total) || "-"}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ),
            )}
          </Swiper>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-96">
            <h2 className="text-xl font-bold mb-4">Catatan</h2>

            {loadingNote ? (
              <div className="text-sm text-gray-600">Loading...</div>
            ) : (
              <textarea
                key={modalOrderId ?? "closed"}
                className="w-full px-4 py-2 border rounded-lg min-h-64"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Tulis catatan di sini..."
              />
            )}

            <div className="flex justify-end gap-4 mt-4">
              <button
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                onClick={() => {
                  setIsModalOpen(false);
                  setModalOrderId(null);
                }}
              >
                Batal
              </button>
              <button
                className="bg-merah-no hover:bg-merah-hover text-white px-4 py-2 rounded"
                onClick={() => handleSave(modalOrderId)}
                disabled={loadingNote}
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}
      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Batalkan Purchase Order?</DialogTitle>
            <DialogDescription>
              Tindakan ini akan membatalkan Purchase Order yang dipilih.
              Lanjutkan?
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="gap-4 sm:gap-2">
            <DialogClose asChild>
              <button
                type="button"
                className="px-4 py-2 rounded border"
                disabled={isCancelling}
                onClick={closeConfirm}
              >
                Keluar
              </button>
            </DialogClose>

            <button
              type="button"
              className="px-4 py-2 rounded bg-red-600 text-white disabled:opacity-60"
              onClick={confirmCancelNow}
              disabled={isCancelling}
            >
              {isCancelling ? "Memproses..." : "Ya, Batalkan"}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {isEditOrderOpen && (
        <Dialog open={isEditOrderOpen} onOpenChange={setIsEditOrderOpen}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Ubah Nomor PO</DialogTitle>
              <DialogDescription>
                Ubah nomor purchase order sesuai kebutuhan.
              </DialogDescription>
            </DialogHeader>

            <div className="mt-4">
              <input
                type="text"
                value={orderNoInput}
                onChange={(e) => setOrderNoInput(e.target.value)}
                className="w-full border rounded px-3 py-2"
              />
              {orderNoError && (
                <p className="text-red-500 text-xs mt-1">{orderNoError}</p>
              )}
            </div>

            <DialogFooter>
              <button
                className="px-4 py-2 rounded bg-gray-200"
                onClick={() => setIsEditOrderOpen(false)}
              >
                Batal
              </button>
              <button
                className="px-4 py-2 rounded bg-blue-600 text-white"
                onClick={handleAttemptSave}
                disabled={savingOrderNo}
              >
                {savingOrderNo ? "Menyimpan..." : "Simpan"}
              </button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {isConfirmOpen && (
        <Dialog open={isConfirmOpen} onOpenChange={setIsConfirmOpen}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Konfirmasi Perubahan</DialogTitle>
              <DialogDescription>
                Pastikan Anda ingin mengubah Nomor PO.
              </DialogDescription>
            </DialogHeader>

            <div className="mt-2 text-sm space-y-1">
              <p>
                Dari: <b>{originalOrderNo || "(kosong)"}</b>
              </p>
              <p>
                Menjadi: <b>{orderNoInput}</b>
              </p>
            </div>

            <DialogFooter>
              <button
                className="px-4 py-2 rounded bg-gray-200"
                onClick={() => setIsConfirmOpen(false)}
                disabled={savingOrderNo}
              >
                Batal
              </button>
              <button
                className="px-4 py-2 rounded bg-red-600 text-white"
                onClick={handleConfirmAndSave}
                disabled={savingOrderNo}
              >
                {savingOrderNo ? "Menyimpan..." : "Ya, Simpan"}
              </button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
